import { render } from "./CourseBasic.vue?vue&type=template&id=0ed748f2&scoped=true"
import script from "./CourseBasic.vue?vue&type=script&lang=js"
export * from "./CourseBasic.vue?vue&type=script&lang=js"

import "./CourseBasic.vue?vue&type=style&index=0&id=0ed748f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed748f2"]])

export default __exports__